module.exports = __webpack_public_path__ + "static/media/element.2f0a8346.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/intro-5/element.png
// module id = 726
// module chunks = 0